import { onMounted } from 'vue'
import { hasValidUserSession } from '@/services/identity-client'
import { resolveIdentityInteraction } from '@/services/identity-events'

/**
 * Should be included at the top level entry for a vertical
 * to fire the login success event for Identity login.
 */
export const useIdentityLoginEvent = () => {
  onMounted(async () => {
    /**
     * Because we use a page transition to go from
     * ID callback -> app, we need to call the marketing event here
     * (vs in the callback) to associate to the correct vertical.
     */
    try {
      if (await hasValidUserSession()) {
        resolveIdentityInteraction()
      }
    } catch (e) {
      // ignore errors if we have an invalid referrer
    }
  })
}
